export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Sidan hittades inte',
    description: 'Sidan du letar efter finns inte',
    goBack: 'Tillbaka till startsidan',
  },
  common: {
    loading: 'Laddar...',
    noData: 'Inga data tillgängliga',
    error: 'Något gick fel, försök igen',
    retry: 'Försök igen',
    authExpired: 'Sessionen har löpt ut, logga in igen',
    requestFailed: 'Begäran misslyckades',
    networkError: 'Nätverksfel, kontrollera din anslutning',
    skipToContent: 'Gå till huvudinnehåll',
  },
  nav: {
    dashboard: 'Översikt',
    visa: 'Visum',
    cost: 'Kostnad',
    timezone: 'Tidszon',
    tax: 'Skatt',
    guide: 'Guide',
    login: 'Logga in',
  },
  footer: {
    about: 'Om oss',
    privacy: 'Integritet',
    terms: 'Villkor',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'Ditt digitala nomadliv, organiserat',
      subtitle: 'Allt-i-ett-plattform för visumspårning, kostnadsjämförelse, tidszonskoordinering, skatteefterlevnad och stadsguider',
      cta: 'Kom igång gratis',
      learnMore: 'Läs mer',
    },
    features: {
      title: 'Funktioner',
      visa: { title: 'Visumspårning', desc: 'Spåra visumtyper, giltighet och påminnelser om förnyelse' },
      cost: { title: 'Kostnadsjämförelse', desc: 'Jämför levnadskostnader: boende, mat, transport med mera' },
      timezone: { title: 'Tidszonshantering', desc: 'Fler-tidszonsklockor och möteskoordinering över tidszoner' },
      tax: { title: 'Skatteassistent', desc: 'Gränsöverskridande skatteregler och vistelsedagsvarningar' },
      guide: { title: 'Stadsguide', desc: 'Detaljerade guider för digitala nomaddestinationer världen över' },
    },
    stats: {
      countries: 'Länder',
      cities: 'Städer',
      languages: 'Språk',
    },
  },
  login: {
    login: 'Logga in',
    register: 'Registrera',
    subtitle: 'Logga in på NomadMate och hantera ditt nomadliv',
    registerSubtitle: 'Skapa ett konto och börja ditt digitala nomadäventyr',
    email: 'E-post',
    emailPlaceholder: 'din@email.com',
    emailInvalid: 'Ange en giltig e-postadress',
    username: 'Användarnamn',
    usernamePlaceholder: 'Ange användarnamn',
    password: 'Lösenord',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'Lösenordet måste vara minst 6 tecken',
    confirmPassword: 'Bekräfta lösenord',
    confirmPasswordPlaceholder: 'Ange lösenordet igen',
    passwordMismatch: 'Lösenorden matchar inte',
    loading: 'Loggar in...',
    error: 'Inloggning misslyckades, försök igen',
    orContinueWith: 'Eller fortsätt med',
    noAccount: 'Inget konto?',
    hasAccount: 'Har redan ett konto?',
  },
  dashboard: {
    welcome: 'Välkommen tillbaka, {name}',
    subtitle: 'Översikt över ditt nomadliv',
    stats: {
      activeVisas: 'Aktiva visum',
      daysUntilExpiry: 'Dagar till utgång',
      citiesCompared: 'Jämförda städer',
      timezones: 'Spårade tidszoner',
    },
    expiryAlerts: 'Visumutgångsvarningar',
    noAlerts: 'Inga kommande utgångsvarningar',
    daysLeft: '{days} dagar kvar',
    worldClocks: 'Världsklockor',
    quickActions: 'Snabbåtgärder',
    actions: {
      visa: 'Visumspårning',
      cost: 'Kostnadsjämförelse',
      timezone: 'Tidszoner',
      tax: 'Skatteassistent',
      guide: 'Stadsguide',
    },
    recentActivity: 'Senaste aktivitet',
    noActivity: 'Ingen senaste aktivitet',
  },
  visa: {
    title: 'Visumhantering',
    subtitle: 'Spåra och hantera din visuminformation',
    searchPlaceholder: 'Sök efter land...',
    allRegions: 'Alla regioner',
    regions: {
      europe: 'Europa',
      asia: 'Asien',
      americas: 'Amerika',
      oceania: 'Oceanien',
    },
    noCountries: 'Inga länder hittades',
    requirements: 'Krav',
    documents: 'Nödvändiga dokument',
    track: 'Spåra detta visum',
    applyUrl: 'Ansökningslänk',
    myTracked: 'Mina spårade visum',
  },
  cost: {
    title: 'Levnadskostnader',
    subtitle: 'Jämför levnadskostnader mellan olika städer',
    selectCities: 'Välj städer',
    selectHint: 'Välj 2-4 städer att jämföra',
    compare: 'Jämför',
    selectedCount: '{count} städer valda',
    comparison: 'Jämförelse',
    category: 'Kategori',
    nomadScore: 'Nomadpoäng',
    budgetFinder: 'Budgetsökare',
    budgetPlaceholder: 'Ange månadsbudget',
    findCities: 'Hitta städer',
    aiSuggestion: 'AI-förslag kommer snart',
  },
  timezone: {
    title: 'Tidszonshantering',
    subtitle: 'Hantera scheman och möten i flera tidszoner',
    addTimezone: 'Lägg till tidszon',
    noTimezones: 'Klicka ovan för att lägga till tidszoner',
    meetingScheduler: 'Mötesplanerare',
    meetingHint: 'Välj deltagarnas tidszoner för att hitta bästa mötestid',
    findMeeting: 'Hitta mötestid',
    finding: 'Söker...',
    bestTime: 'Bästa tiden',
    workingOverlap: 'Överlappning arbetstid',
  },
  tax: {
    title: 'Skatteassistent',
    subtitle: 'Gränsöverskridande skatteberäkning och efterlevnad',
    rules: 'Skatteregler',
    selectCountry: 'Välj land',
    thresholdDays: 'Tröskelvärde vistelsedagar',
    days: 'dagar',
    taxRates: 'Skattesatser',
    reportingRequirements: 'Deklarationsskyldigheter',
    importantDates: 'Viktiga datum',
    residenceTracker: 'Vistelsedagsspårare',
    noResidenceDays: 'Inga vistelsedagar registrerade',
    riskIndicator: 'Skatteriskindikator',
    noRiskData: 'Inga riskdata tillgängliga',
    countries: {
      portugal: 'Portugal',
      thailand: 'Thailand',
      spain: 'Spanien',
      germany: 'Tyskland',
      estonia: 'Estland',
      georgia: 'Georgien',
      croatia: 'Kroatien',
      mexico: 'Mexiko',
      colombia: 'Colombia',
      indonesia: 'Indonesien',
      japan: 'Japan',
      southKorea: 'Sydkorea',
      unitedKingdom: 'Storbritannien',
      unitedStates: 'USA',
    },
  },
  guide: {
    title: 'Stadsguide',
    subtitle: 'Guider för digitala nomaddestinationer världen över',
    allContinents: 'Alla',
    noCities: 'Inga städer hittades',
    backToList: 'Tillbaka till listan',
    internetQuality: 'Internetkvalitet',
    safetyRating: 'Säkerhetsbetyg',
    climate: 'Klimat',
    communitySize: 'Gemenskapsstorlek',
    coworkingSpaces: 'Coworkingutrymmen',
    noCoworking: 'Inga coworkingutrymmen tillgängliga',
    day: 'dag',
  },
  settings: {
    title: 'Inställningar',
    subtitle: 'Hantera ditt konto och appinställningar',
    profile: 'Profil',
    username: 'Användarnamn',
    email: 'E-post',
    saveProfile: 'Spara profil',
    saving: 'Sparar...',
    language: 'Språk',
    notifications: 'Aviseringar',
    visaExpiryNotif: 'Visumutgångspåminnelser',
    taxReminderNotif: 'Skattepåminnelser',
    appearance: 'Utseende',
    light: 'Ljust',
    dark: 'Mörkt',
    baseTimezone: 'Bastidszon',
    dangerZone: 'Riskzon',
    dangerDesc: 'Dessa åtgärder är oåterkalleliga, fortsätt med försiktighet',
    deleteAccount: 'Radera konto',
    confirmDelete: 'Bekräfta kontoradering',
    confirmDeleteDesc: 'Detta raderar permanent ditt konto och all data. Denna åtgärd kan inte ångras.',
    cancel: 'Avbryt',
    confirm: 'Radera',
  },
  about: {
    title: 'Om oss',
    subtitle: 'NomadMate - Assistent för digitala nomader',
    version: 'Version',
    versionNumber: '1.0.0',
    description: 'NomadMate är en assistent designad för digitala nomader, med visumhantering, levnadskostnadsjämförelse, tidszonshantering, skatteberäkning och stadsguider för att underlätta ditt globala nomadliv.',
    openSource: 'Open source-tack',
    openSourceDesc: 'Detta projekt är byggt på följande utmärkta open source-projekt',
    contact: 'Kontakta oss',
    support: 'Teknisk support',
    feedback: 'Feedback',
    privacyPolicy: 'Integritetspolicy',
    terms: 'Användarvillkor',
  },
}
